import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Droppable, DragDropContext } from "react-beautiful-dnd";
import { Grid } from "@material-ui/core";
import AlertDialogSlide from "../../../ui/AlertaConfirm";
import { startAlerta } from "../../../../actions/ui/alertas";
import {
  getDocumentacionSolicitud,
  deleteDocumentacionSolicitud,
  getTiposDocumentacion,
} from "../../../../actions/empadronamiento/Empadronamiento";
import { EmpadronamientoDocumentacionTarjeta } from "../../Ingreso/EmpadronamientoDocumentacionTarjeta";


export const InformacionDocumentacionEmpadronamiento = (props) => {
  const dispatch = useDispatch();
  const baseUrl = process.env.REACT_APP_URL;

  const [open, setOpen] = useState(false);
  const [idDocumentoSolicitud, setIdDocumentoSolicitud] = useState(0);
  const [idTipoDoc, setIdTipoDoc] = useState(0);

  const {
    documentacion,
    solicitudSeleccionada = {},
    tiposDocumentacion,
  } = useSelector((state) => state.empadronamiento);

  let idSolicitud = null;

  if (solicitudSeleccionada) {
    idSolicitud = solicitudSeleccionada.idSolicitud;
  }

  let arrayURLs = [];
  let documentacionCopy = [...documentacion];
  let tiposDocumentacionCopy = [...tiposDocumentacion];

  if (documentacion?.length > 0) {
    for (var j = 0; j < tiposDocumentacionCopy.length; j++) {
      for (var i = 0; i < documentacionCopy.length; i++) {
        if (
          tiposDocumentacionCopy[j].idTipoDoc === documentacionCopy[i].idTipoDoc
        ) {
          let obj = {};
          obj.url =
            baseUrl +
            "/" +
            documentacionCopy[i].urlCarpeta +
            documentacionCopy[i].nombreDocumento;
          obj.id = `${documentacionCopy[i].idDocumentacionSolicitud},idTipoDoc=${documentacionCopy[i].idTipoDoc}`;
          arrayURLs.push(obj);
        }
      }
      tiposDocumentacionCopy[j].URLs = arrayURLs;
      arrayURLs = [];
    }
  } else {
    arrayURLs = [];
    tiposDocumentacion.forEach((url) => {
      url.URLs = [];
    });
    documentacionCopy = [];
  }

  const deleteModalHandler = (confirm) => {
    if (confirm === "SI") {
      const esDocumentoObligatorio = tiposDocumentacionCopy.find(
        (tipoDocumento) => tipoDocumento.idTipoDoc === idTipoDoc
      )?.obligatorio;
      if (!esDocumentoObligatorio) {
        dispatch(deleteDocumentacionSolicitud(idSolicitud, idDocumentoSolicitud));
      } else {
        dispatch(
          startAlerta(
            `No se puede borrar documentación obligatoria.`,
            "error",
            "Error"
          )
        );
      }
    }
    setOpen(false);
  };

  const handleOnDragEnd = (result) => {
    if(!props.disabled){
      const { destination } = result;

      if (!destination) {
        return;
      }

      const idDocumentacionSolicitud = parseInt(
        result.draggableId.replace("documentacion", "")
      );
      const idTipoDoc = parseInt(result.draggableId.split(",")[1]?.split("=")[1]);

      if (destination.droppableId === "eliminardoc") {
        setIdDocumentoSolicitud(idDocumentacionSolicitud);
        setIdTipoDoc(idTipoDoc);
        setOpen(true);
      }
    }else{
      dispatch(
        startAlerta(
          `No se puede modificar la documentacion.`,
          "error",
          "Error"
        )
      );
    }
  };

  useEffect(() => {
    dispatch(getTiposDocumentacion(solicitudSeleccionada.idTipoEmpadronamiento,props.idPatologia));
    if (idSolicitud) dispatch(getDocumentacionSolicitud(idSolicitud));
  }, [idSolicitud]);
  console.log(tiposDocumentacionCopy)
  return (
    <React.Fragment>
      <div style={{ marginTop: "2rem" }}>
        <AlertDialogSlide
          open={open}
          setOpen={setOpen}
          mensaje="Está seguro que desea eliminar la imagen?"
          handleDecision={deleteModalHandler}
        />
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={1} direction="row" alignItems="center">
                {tiposDocumentacionCopy?.map((item, index) => (
                  <Droppable
                    key={item.idTipoDoc}
                    droppableId={`idTipoDoc${item.idDocumentacionSolicitud}`}
                  >
                    {(provided) => (
                      <Grid
                        key={item.idTipoDoc}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        item
                        style={{ alignSelf: "start" }}
                      >
                        <EmpadronamientoDocumentacionTarjeta
                            idTipoEmpadronamiento={solicitudSeleccionada.idTipoEmpadronamiento}
                            idSolicitud={idSolicitud}
                            item={item}
                            key={index}
                            titulo={`${item?.descripcion}`}
                            idTipoDoc={item.idTipoDoc}
                            urls={item.URLs}
                            disabledUp={true}
                            disabledDown={false}
                          />
                        {provided.placeholder}
                      </Grid>
                    )}
                  </Droppable>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </DragDropContext>
      </div>
    </React.Fragment>
  );
};
